export * from '@ansyn/core/models/overlay.model';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/overlays/models/overlay.model.ts